import React, { useEffect } from "react";
import IsmsHeroPage from "../../../components/Isms/IsmsHeroPage";
import Hero from "../../../components/home/Hero";
import NavBar from "../../../components/NavBar";
import WhoCanUse from "../../../components/Isms/WhoCanUse";
import Carousel from "../../../components/Isms/Carousel";
import HowItWorks from "../../../components/Isms/HowItWorks";
import WhatsNext from "../../../components/Isms/WhatsNext";
import Footer from "../../../components/Footer";
import pic from "../../../images/IsmsTherapist.jpg";
import pic2 from "../../../images/TherapistIsms.jpg";
import pic3 from "../../../images/IsmsSchools.jpg";
import pic4 from "../../../images/IsmsParents.jpg";
import pic5 from "../../../images/IsmsRehabit.jpg";
import support from "../../../images/friendship.png";
import mission from "../../../images/target.png";
import test from "../../../images/exam.png";
import workfromhome from "../../../images/work-from-home.png";
import comfort from "../../../images/working-woman.png";
import access from "../../../images/easy-access.png";
// import activity from "../../../images/isms/activity.jpg";
import calender from "../../../images/isms/calender.png";
import manage from "../../../images/isms/manage.jpg";
import track from "../../../images/isms/track.png";
import managment from "../../../images/isms/managment.png";
import activityManage from "../../../images/isms/activityManage.png";
import ScrollToTop from "react-scroll-to-top";
export const CarouselContent = [
  {
    icon: "",
    h1: "ELiNA's journey has been a guiding and helpful experience throughout theassessment process of my child. It helped me understand the strengths and lacking areas of development of my child. Systematic and simple assessment activities were given to my child to assess the child's level of development in every areas of development. We had done SAIL's assessment activities in our home without much difficulty. Interactions with the ELiNA team was always been seemless.",
    p: "- Sugitha Vidyasagar, mother of Vidyuth",
  },
  {
    icon: "",
    h1: "Hi all, I just wanted to share my experience with ELiNA and how it helped me to figure out which method of learning helps my son to move forward. Their assessment pattern was very elaborate which covers all the skills which I've never experienced anywhere. As per their advice I've changed his mode of learning and I feel it's helping him a lot.The SAIL program and it's detailed report was very helpful. Thank you so much to the team for their constant support throughout the program and guiding me in the proper streamline.",
    p: "Priyadarshini, Mother of Pranav Sathya.",
  },
  {
    icon: "",
    h1: "App is very good. It is definitely a useful and quick learning guide for kids which we can use at any point in time when we don't have study books. Anywhere we can operate and kids will enjoy the learning.",
    p: "Parent of a 6 year old Kid with Autism.",
  },
];

const HowItWorksContent = [
  {
    video: manage,
    h1: "Child profile dashboard",
    li: [
      "Child information",
      "Contact information",
      "Educational information",
      "Intervention plans",
      "Progress tracking",
      "Therapy & support",
      "Additional documents",
    ],
    ImgDirection: "left",
  },
  {
    video: calender,
    h1: "Integrated Child Support Management System (ICSMS): Enhancing coordination and care",
    li: [
      "Therapist allocation ",
      "Role-Based permissions",
      "Integrated therapy team",
      "School integration",
      "Security and compliance",
      "User-friendly interface",
    ],
  },
  {
    video: managment,
    h1: "Therapy session management",
    li: [
      "Individualized session planning",
      "Recurring session scheduling",
      "Tele therapy integration",
      "Comprehensive schedule tracking",
      "Reporting and presentation coordination",
    ],
    ImgDirection: "left",
  },
  {
    video: activityManage,
    h1: "Integrated child activity management and parent engagement system",
    li: [
      "Structured activities for home",
      "Feedback and communication hub",
      "Specialist collaboration and updates",
      "Activities management within ISMS",
      "Tailored activity selection",
      "Centralized activity repository",
      "Organization-wide activity catalog",
      "Custom questionnaire creation",
      "Integrated assessment approach",
    ],
  },

  {
    video: track,
    h1: "Integrated tracking and coordination system for all stakeholders ",
    li: [
      "      Event tracking across the organization",
      "Trend analysis",
      "Easy scheduling and assessment procedures",
      "Tailored program preparation",
    ],
    ImgDirection: "left",
  },
];

const KeyContent = [
  {
    icon: workfromhome,
    p: (
      <span>
        <span className="font-bold lg:text-xl text-pink-500">
          Remote collaboration:{" "}
        </span>
        Teams can collaborate remotely to overcome distance.
      </span>
    ),
  },
  {
    icon: comfort,

    p: (
      <span>
        <span className="font-bold lg:text-xl text-pink-500">Convenient: </span>
        superior home-based evaluation for optimal child development.
      </span>
    ),
  },
  {
    icon: support,
    p: (
      <span>
        <span className="font-bold lg:text-xl text-pink-500">
          Personalized support:{" "}
        </span>
        Personalized evaluation support that is tailored.
      </span>
    ),
  },
];

const KeyContent2 = [
  {
    icon: mission,
    p: (
      <span>
        <span className="font-bold lg:text-xl text-pink-500">Measurable: </span>
        Weekly goal tracking with timely progress reports.
      </span>
    ),
  },
  {
    icon: access,
    p: (
      <span>
        <span className="font-bold lg:text-xl text-pink-500">Accessible: </span>
        Accessible device-ready assessment<br></br> tool.
      </span>
    ),
  },
  {
    icon: test,
    p: (
      <span>
        <span className="font-bold lg:text-xl text-pink-500">Resources: </span>
        Assessment resource with learner companion for enhanced skill
        evaluation.
      </span>
    ),
  },
];

const WhoCanUseContent = [
  {
    WhoCanUseImg: pic4,
    p: <span > Parents</span>,
    nav:"/#/parent-form"
  },
  {
    WhoCanUseImg: pic3,
    p: <span > Schools</span>,
    nav:"/#/school-form"
  },
  {
    WhoCanUseImg: pic,
    p: (
      <span>
        <span >Therapy centers</span>
      </span>
    ),
    nav:"/#/service-form"
  },

  {
    WhoCanUseImg: pic5,
    p: <span > Rehabilitation centers</span>,
    nav:"/#/service-form"
  },
  {
    WhoCanUseImg: pic2,
    p: (
      <span>
        <span >Individual therapist </span>
      </span>
    ),
    nav:"/#/service-form"
  },
];

const Imis = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const YourCustomArrowIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="white" // The arrow color is set to white
    >
      <path d="M12 2L5 9h4v9h6V9h4l-7-7z" />
    </svg>
  );
  return (
    <>
      <IsmsHeroPage />
      <WhoCanUse
        KeyContent={KeyContent}
        KeyContent2={KeyContent2}
        WhoCanUseContent={WhoCanUseContent}
      />
      <Carousel CarouselContent={CarouselContent} />
      <HowItWorks HowItWorksContent={HowItWorksContent} />
      <WhatsNext />
      <ScrollToTop
        smooth
        style={{
          backgroundColor: "#0048ff",
          display: "flex",
          borderRadius: "20px",
          justifyContent: "center",
          alignItems: "center",
          bottom: "70px",
          right: "23px",
          width: "40px",
          height: "40px",
        }}
        component={<YourCustomArrowIcon />}
      />
    </>
  );
};

export default Imis;
